<template>
  <div id="app">
    <div class="col-md-12">
      <div class="bg-plans-form mt-10">
        <h2>
          แผนงานทั้งหมด
        </h2>
        <table ref="table_plans" id="table_plans" class="display" style="width:100%">
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { Grid } from "gridjs";
import "gridjs/dist/theme/mermaid.css";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import DataTable from 'datatables.net-bs4';
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import 'datatables.net-rowgroup-bs4';
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.css';
import $ from "jquery";
import moment from "moment";
import FetchService from "@/core/services/fetch.service";
export default {
  name: 'app',
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL || "http://localhost:3000",
      gridData: [],
      time1: null,
      time2: null,
      dataSet: [],
      masterDataPlans: [],
      jobType: [
        {
          value: 0,
          text: 'Service'
        },
        {
          value: 1,
          text: 'Install'
        }
      ],
      teams: [
        {
          value: 0,
          text: "กรุณาเลือก"
        },
        {
          value: 1,
          text: "ทีม A"
        },
        {
          value: 2,
          text: "ทีม b"
        },
        {
          value: 3,
          text: "ทีม b"
        }
      ],
      masterFormData: {
        teamData: []
      },
      pageNumberLast: 0,
      pageSearchText: ""
    };
  },
  components: {
    DatePicker
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Plans", route: "All plans" },
      { title: "" }
    ]);

    const value = this.getWithExpiry("plans_page_number")
    this.pageNumberLast = value ? value : 0

    const text = this.getWithExpiry("page_search_text")
    this.pageSearchText = text ? text : ""

    this.getTeam()
    this.getTableData()

  },
  methods: {
    getTableData() {
      // this.dataSet = [
      //   ['L-230515-001', 'ใบหยก', 'Mitsubishi', 'Mitsubishi Thailand', '10', '2023-05-10', '2023-05-25', 'Service', '<span class="badge badge-pill badge-secondary">To do</span>', '<span class="badge badge-pill badge-secondary">ลุงอูด</span>',],
      //   ['L-230515-002', 'มหานคร', 'Hitachi', 'Hitachi Thailand', '5', '2023-05-01', '2023-05-15', 'Service', '<span class="badge badge-pill badge-warning">On going</span>', '<span class="badge badge-pill badge-warning">ลุงติ๊ก</span>'],
      //   ['L-230515-003', 'ใบหยก', 'Mitsubishi', 'Mitsubishi Thailand', '10', '2023-05-8', '2023-05-20', 'Service', '<span class="badge badge-pill badge-success">Completed</span>', '<span class="badge badge-pill badge-success">ลุงตุด</span>'],
      // ]

      var myHeaders = new Headers();
      myHeaders.append("Cookie", "connect.sid=s%3AZ6_DEe7M9FtUAyCFLzXyV0DAnpxLrgc2.SOpMwaW7ug7csRb4cxLby2rXR8mIR4lmijG4oOmiRsk");

      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      }

      FetchService.get("/getplans", (response) => {
        if (response) {
            let res = JSON.parse(response)
            this.masterDataPlans = res.allPlans
            let that = this
            this.dataSet = res.allPlans.map(e => {
              let teamNow = this.masterFormData.teamData.find(row => {
                return row._id == e.teamID
              })
              
              let eqText = ""
              e.equipment.forEach((row, i) => {
                eqText += eqText != "" ? "<br />" : ""
                eqText += `${i + 1}.${row.text}`
              });

              return [
                e.planJobID,
                e?.detail_company?.buildingName ? e.detail_company.buildingName : e.building_ID,
                eqText,
                e?.statusDetail ? e.statusDetail : "",
                teamNow?.name ? `<span class="badge badge-pill badge-success">${teamNow.name}</span>` : "",
                e.create_date ? moment(e.create_date).format("YYYY-MM-DD HH:mm:ss") : "",
                e.appointmentDate ? moment(e.appointmentDate).format("YYYY-MM-DD HH:mm:ss") : "",
                `<span class="badge badge-pill ${(e.planStatus == 0) ? 'badge-secondary' : (e.planStatus == 1) ? 'badge-primary' : (e.planStatus == 2) ? 'badge-success' : (e.planStatus == 3) ? 'badge-danger' : ""}">${(e.planStatus == 0) ? 'To-do' : (e.planStatus == 1) ? 'On going' : (e.planStatus == 2) ? 'Complete' : (e.planStatus == 3) ? 'In Complete' : ""} </span>`,
              ]
            })
            this.pageStart()
          }
      })

      // fetch(this.baseUrl + "/getplans", requestOptions)
      //   .then(response => response.text())
      //   .then(result => {
      //     if (result) {
      //       let res = JSON.parse(result)
      //       this.masterDataPlans = res.allPlans
      //       let that = this
      //       this.dataSet = res.allPlans.map(e => {

      //         let eventType = that.jobType.find(row => {
      //           return row.value == e.event_type
      //         })

      //         // console.log(e.planJobID, e)

      //         let teamNow = this.masterFormData.teamData.find(row => {
      //           return row._id == e.teamID
      //         })

      //         return [
      //           e.planJobID,
      //           e?.detail_company?.buildingName ? e.detail_company.buildingName : e.building_ID,
      //           e?.statusDetail ? e.statusDetail : "",
      //           teamNow?.name ? `<span class="badge badge-pill badge-success">${teamNow.name}</span>` : "",
      //           0,
      //           e.create_date ? moment(e.create_date).format("YYYY-MM-DD HH:mm:ss") : "",
      //           e.appointmentDate ? moment(e.appointmentDate).format("YYYY-MM-DD HH:mm:ss") : "",
      //           eventType?.text || "",
      //           `<span class="badge badge-pill ${(e.planStatus == 0) ? 'badge-secondary' : (e.planStatus == 1) ? 'badge-primary' : (e.planStatus == 2) ? 'badge-success' : (e.planStatus == 3) ? 'badge-danger' : ""}">${(e.planStatus == 0) ? 'To-do' : (e.planStatus == 1) ? 'On going' : (e.planStatus == 2) ? 'Complete' : (e.planStatus == 3) ? 'In Complete' : ""} </span>`,
      //         ]
      //       })
      //       this.pageStart()
      //     }
      //   })
      //   .catch(error => console.log('error', error));
      
    },
    pageStart() {
      let that = this
      let table = new DataTable('#table_plans', {
        data: this.dataSet,
        columns: [
          { title: 'เลขงาน' },
          { title: 'ชื่ออาคาร' },
          { title: 'อุปกรณ์ที่เสนอ' },
          { title: 'รายละเอียดสถานะ' },
          { title: 'ทีม' },
          { title: 'วันที่แจ้ง' },
          { title: 'วันที่นัดหมาย' },
          { title: 'สถานะงาน' },
        ],
        order: [[5, 'desc']],
        rowGroup: {
          dataSrc: 1
        },
        dom: 'Bfrtip',
        displayStart: that.pageNumberLast
      });
      $('#table_plans').on('click', 'td', (event) => {
        let data = table.row(event.currentTarget).data();
        let id = data[0]
        let plan = this.masterDataPlans.find(e => {
          return e.planJobID == id
        })
        this.$router.push({
          name: "PlansAll2", //use name for router push
          params: { id: plan._id }
        })
      });
      $('#table_plans').on('page.dt', function () {
        var info = table.page.info();
        that.setWithExpiry("plans_page_number", (info.page * 10) - 1 , 900000)
      });
      $('.dt-search input[type="search"]').on('keyup', function () {
        that.setWithExpiry("page_search_text", this.value , 900000)
      });
      table.search(that.pageSearchText).draw();
    },
    beforeDestroy() {
      $('#table_plans').off('click', 'td');
      this.temp.destroy();
    },
    getTeam() {
      FetchService.get("/getteam", (response) => {
        if (response) {
          response = JSON.parse(response)
          this.masterFormData.teamData = response.thisTeam
        }
      })
    },
    setWithExpiry(key, value, ttl) {

      localStorage.removeItem(key)

      const now = new Date()

      // `item` is an object which contains the original value
      // as well as the time when it's supposed to expire
      const item = {
        value: value,
        expiry: now.getTime() + ttl,
      }
      localStorage.setItem(key, JSON.stringify(item))
    },
    getWithExpiry(key) {
      const itemStr = localStorage.getItem(key)
      // if the item doesn't exist, return null
      if (!itemStr) {
        return null
      }
      const item = JSON.parse(itemStr)
      const now = new Date()
      // compare the expiry time of the item with the current time
      if (now.getTime() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key)
        return null
      }
      return item.value
    }
  }
};
</script>

<style>
/* #app {
  font-family: Arial, Helvetica, sans-serif -webkit-font-smoothing system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif -moz-osx-font-smoothing grayscale;
} */

/* label {
  font: 1rem 'Fira Sans', sans-serif;
} */

.bg-plans-form {
  background-color: #FFFFFF;
  border-radius: 10px;
  padding: 20px;
  font-size: 1rem;
  font-weight: 500;
}

input,
label {
  margin: 0.5rem 0;
}

#table_plans table {
  border-collapse: separate;
  border-spacing: 0;
}

#table_plans th {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

.dataTables_wrapper .dataTable thead th {
  border-top: solid 1px #DEDFE0;
  background-color: #f9fafb;
}


#table_plans thead tr:first-child th:first-child {
  border-top-left-radius: 10px;
}

#table_plans thead tr:first-child th:last-child {
  border-top-right-radius: 10px;
}

#table_plans thead tr:first-child th {
  border-top-style: solid;
}

#table_plans thead tr th:first-child {
  border-left-style: solid;
}

#table_plans td {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

#table_plans tbody th {
  border-style: none solid solid solid;
}

#table_plans tbody tr:first-child td:first-child {
  border-top-left-radius: 10px;
}

#table_plans tbody tr:first-child td:last-child {
  border-top-right-radius: 10px;
}

#table_plans tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

#table_plans tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

#table_plans tbody tr:first-child td {
  border-top-style: solid;
}

#table_plans tbody tr td:first-child {
  border-left-style: solid;
}

#table_plans tbody tr:first-child td:first-child.dataTables_empty {
  border-top-left-radius: 0px;
}

#table_plans tbody tr:first-child td:last-child.dataTables_empty {
  border-top-right-radius: 0px;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before {
  content: "" !important;
}

table.dataTable thead .sorting:after {
  content: "" !important;
}

table.dataTable thead .sorting_asc:after {
  content: "▲" !important;
  content: "▲" /"" !important;
}

table.dataTable thead .sorting_desc:after {
  content: "▼" !important;
  content: "▼" /"" !important;
}

table.dataTable tr.dtrg-group th {
  background-color: #f2f2f2;
  text-align: left;
}

#table_plans tbody tr:hover {
  background-color: #f5f5f5;
  /* สีที่คุณต้องการเมื่อ hover */
  cursor: pointer;
}

.dt-search {
  text-align: right;
  padding-bottom: 0.85rem;
}

.dt-search {
  text-align: right;
}
</style>